import { useProperty } from '@eti/providers';

const useNameFormatter = () => {
  const { p } = useProperty();
  const showLastNameBeforeFirstName = p('IbeClient.ShowLastNameBeforeFirstName');

  const formatName = (
    givenName?: string | null,
    familyName?: string | null,
    fullName?: string | null,
  ) => {
    const names = showLastNameBeforeFirstName ? [familyName, givenName] : [givenName, familyName];

    const formatted = names.filter(Boolean).join(' ');

    return formatted || fullName || null;
  };

  return { formatName };
};

export default useNameFormatter;
